module.exports = __webpack_public_path__ + "img/katarina_kitchen_6.9eb99e54.jpg";